<template>
  <b-row class="m-b-90">
    <b-col
      v-for="(link, i) in linkGroup"
      :key="i"
      md="4"
      sm="12"
      class="text-center m-b-10"
    >
      <b-link
        :href="link.href"
        class="btn link-group-item"
      >
        {{ link.label }}
      </b-link>
    </b-col>
  </b-row>
</template>

<script>
import linkGroup from '@/constants/linkGroup';

export default {
  name: 'BtnGroup',
  data() {
    return {
      linkGroup,
    };
  },
};
</script>
